/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUserItem } from './FuelUserItem';
import {
    FuelUserItemFromJSON,
    FuelUserItemFromJSONTyped,
    FuelUserItemToJSON,
    FuelUserItemToJSONTyped,
} from './FuelUserItem';

/**
 * 
 * @export
 * @interface GetTotalFuelResponse
 */
export interface GetTotalFuelResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTotalFuelResponse
     */
    fuelTotal: number;
    /**
     * 
     * @type {number}
     * @memberof GetTotalFuelResponse
     */
    totalInUsd: number;
    /**
     * 
     * @type {Array<FuelUserItem>}
     * @memberof GetTotalFuelResponse
     */
    topUsers?: Array<FuelUserItem>;
}

/**
 * Check if a given object implements the GetTotalFuelResponse interface.
 */
export function instanceOfGetTotalFuelResponse(value: object): value is GetTotalFuelResponse {
    if (!('fuelTotal' in value) || value['fuelTotal'] === undefined) return false;
    if (!('totalInUsd' in value) || value['totalInUsd'] === undefined) return false;
    return true;
}

export function GetTotalFuelResponseFromJSON(json: any): GetTotalFuelResponse {
    return GetTotalFuelResponseFromJSONTyped(json, false);
}

export function GetTotalFuelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTotalFuelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fuelTotal': json['fuelTotal'],
        'totalInUsd': json['totalInUsd'],
        'topUsers': json['topUsers'] == null ? undefined : ((json['topUsers'] as Array<any>).map(FuelUserItemFromJSON)),
    };
}

export function GetTotalFuelResponseToJSON(json: any): GetTotalFuelResponse {
    return GetTotalFuelResponseToJSONTyped(json, false);
}

export function GetTotalFuelResponseToJSONTyped(value?: GetTotalFuelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fuelTotal': value['fuelTotal'],
        'totalInUsd': value['totalInUsd'],
        'topUsers': value['topUsers'] == null ? undefined : ((value['topUsers'] as Array<any>).map(FuelUserItemToJSON)),
    };
}

